// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Avenir", sans-serif',
  },
  // Aquí puedes agregar más personalizaciones de tu tema, si lo deseas.
});

export default theme;
